import type { ReactNode } from 'react';
import { Route } from 'react-router-dom';
import { RouteWithAuth as LegacyRouteWithAuth } from '@common/components/RouteWithAuth';
import type { RouteWithAuthProps } from '@common/components/RouteWithAuth';
import { ManagerStrongAuthBoundary, useManagerAuthEnabled } from './ManagerAuthProvider';

type ManagerRouteWithAuthProps = RouteWithAuthProps & {
  redirecting?: ReactNode;
};

export const ManagerRouteWithAuth = ({ redirecting, render, ...props }: ManagerRouteWithAuthProps) => {
  if (!useManagerAuthEnabled()) return <LegacyRouteWithAuth render={render} {...props} />;

  return (
    <Route
      {...props}
      render={(routeProps) => {
        const route = render({ ...routeProps, loading: true });
        return <ManagerStrongAuthBoundary redirecting={redirecting}>{route}</ManagerStrongAuthBoundary>;
      }}
    />
  );
};
